import React from "react";
import avif768 from "@/assets/hero-hangar-light-768.avif";
import avif1280 from "@/assets/hero-hangar-light-1280.avif";
import avif1920 from "@/assets/hero-hangar-light-1920.avif";
import webp768 from "@/assets/hero-hangar-light-768.webp";
import webp1280 from "@/assets/hero-hangar-light-1280.webp";
import webp1920 from "@/assets/hero-hangar-light-1920.webp";
import jpg768 from "@/assets/hero-hangar-light-768.jpg";
import jpg1280 from "@/assets/hero-hangar-light-1280.jpg";
import jpg1920 from "@/assets/hero-hangar-light-1920.jpg";

interface HeroBackgroundProps {
  priority?: boolean;
  darkScrim?: boolean;
  /** HSL triplet (e.g. "217 91% 60%") used as the spotlight accent. Defaults to brand blue. */
  accentHue?: string;
}

/**
 * Responsive, format-negotiated hangar background.
 * Single soft dark scrim across all viewports — no cinematic grading.
 */
const HeroBackground: React.FC<HeroBackgroundProps> = ({
  priority = false,
  darkScrim = true,
  accentHue = "0 0% 100%",
}) => {
  const sizes = "100vw";
  const avifSet = `${avif768} 768w, ${avif1280} 1280w, ${avif1920} 1920w`;
  const webpSet = `${webp768} 768w, ${webp1280} 1280w, ${webp1920} 1920w`;
  const jpgSet = `${jpg768} 768w, ${jpg1280} 1280w, ${jpg1920} 1920w`;

  return (
    <div
      className="absolute inset-0 overflow-hidden"
      style={{ ['--hero-accent' as any]: accentHue }}
    >
      <picture>
        <source type="image/avif" srcSet={avifSet} sizes={sizes} />
        <source type="image/webp" srcSet={webpSet} sizes={sizes} />
        <img
          src={jpg1280}
          srcSet={jpgSet}
          sizes={sizes}
          alt=""
          className="w-full h-full object-cover"
          width={1920}
          height={1080}
          loading={priority ? "eager" : "lazy"}
          // @ts-expect-error fetchpriority is a valid HTML attribute
          fetchpriority={priority ? "high" : "low"}
          decoding="async"
        />
      </picture>
      {darkScrim && (
        <div className="absolute inset-0 hero-background-scrim" />
      )}
    </div>
  );
};

export default HeroBackground;
